// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip-Trigger {
  position: relative;
  display: inline-block;
}

.Tooltip {
  position: absolute;
  background-color: #fff;
  color: #333;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 10px;
  z-index: 1000;
  will-change: transform, opacity;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  font-weight: 700;
}
.Tooltip > .Tooltip-Arrow {
  position: absolute;
  width: 0;
  height: 0;
}
.Tooltip.top {
  transform: translate(-50%, -100%);
}
.Tooltip.top > .Tooltip-Arrow {
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #fff;
}
.Tooltip.bottom {
  transform: translate(-50%, 0);
}
.Tooltip.bottom > .Tooltip-Arrow {
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #fff;
}
.Tooltip.left {
  transform: translate(-100%, -50%);
}
.Tooltip.left > .Tooltip-Arrow {
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid #fff;
}
.Tooltip.right {
  transform: translate(0, -50%);
}
.Tooltip.right > .Tooltip-Arrow {
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;AACF;;AACA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,+BAAA;EACA,2CAAA;EACA,gBAAA;AAEF;AADE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAGJ;AADE;EACE,iCAAA;AAGJ;AAFI;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;AAIN;AADE;EACE,6BAAA;AAGJ;AAFI;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAIN;AADE;EACE,iCAAA;AAGJ;AAFI;EACE,WAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,2BAAA;AAIN;AADE;EACE,6BAAA;AAGJ;AAFI;EACE,UAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4BAAA;AAIN","sourcesContent":[".Tooltip-Trigger {\n  position: relative;\n  display: inline-block;\n}\n.Tooltip {\n  position: absolute;\n  background-color: #fff;\n  color: #333;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 10px;\n  z-index: 1000;\n  will-change: transform, opacity; // for better rendering\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n  font-weight: 700;\n  > .Tooltip-Arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n  }\n  &.top {\n    transform: translate(-50%, -100%);\n    > .Tooltip-Arrow {\n      bottom: -5px;\n      left: 50%;\n      transform: translateX(-50%);\n      border-left: 5px solid transparent;\n      border-right: 5px solid transparent;\n      border-top: 5px solid #fff;\n    }\n  }\n  &.bottom {\n    transform: translate(-50%, 0);\n    > .Tooltip-Arrow {\n      top: -5px;\n      left: 50%;\n      transform: translateX(-50%);\n      border-left: 5px solid transparent;\n      border-right: 5px solid transparent;\n      border-bottom: 5px solid #fff;\n    }\n  }\n  &.left {\n    transform: translate(-100%, -50%);\n    > .Tooltip-Arrow {\n      right: -5px;\n      top: 50%;\n      transform: translateY(-50%);\n      border-top: 5px solid transparent;\n      border-bottom: 5px solid transparent;\n      border-left: 5px solid #fff;\n    }\n  }\n  &.right {\n    transform: translate(0, -50%);\n    > .Tooltip-Arrow {\n      left: -5px;\n      top: 50%;\n      transform: translateY(-50%);\n      border-top: 5px solid transparent;\n      border-bottom: 5px solid transparent;\n      border-right: 5px solid #fff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
